import { FundCalendar } from "@/types";
import { saveFundCalendar } from "@/api/FundCalendar";
import { useAtom } from "jotai";
import { ClientStateAtom, SelectedReportingPeriodAtom } from "@/store";
import { toast } from "sonner";

export interface FundCalendarDetailsControllerProps {
  calendar: FundCalendar;
  onEdit: () => void;
  onRefresh: () => void;
}

export const useFundCalendarDetailsController = (
  props: FundCalendarDetailsControllerProps
) => {
  const { calendar, onEdit, onRefresh } = props;
  const [selectedClient] = useAtom(ClientStateAtom);
  const [selectedReportingPeriod] = useAtom(SelectedReportingPeriodAtom);

  const setAsDefault = async () => {
    if (!calendar.fundCalendarId || !selectedClient) return;

    try {
      const updatedCalendar: FundCalendar = {
        ...calendar,
        isDefault: true,
      };

      const success = await saveFundCalendar(updatedCalendar);
      if (success) {
        toast.success("Calendar set as default");
        onRefresh();
      } else {
        toast.error("Failed to set calendar as default");
      }
    } catch (error) {
      console.error("Error setting calendar as default:", error);
      toast.error("An unexpected error occurred");
    }
  };

  return {
    calendar,
    selectedReportingPeriod,
    onEdit,
    setAsDefault,
  };
};
